module.exports = __webpack_public_path__ + "img/04.decdb887.jpg";